import { render } from "./ArtTable.vue?vue&type=template&id=4d210340&scoped=true"
import script from "./ArtTable.vue?vue&type=script&lang=js"
export * from "./ArtTable.vue?vue&type=script&lang=js"

import "./ArtTable.vue?vue&type=style&index=0&id=4d210340&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/acnh-tracker/acnh-tracker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d210340"]])

export default __exports__